import { useMemo } from 'react';
import Snowfall from 'react-snowfall';
import snowflakeImage from '../../assets/snowflake.png';

export const SnowFlakes = () => {
  const images = useMemo(() => {
    const img = document.createElement('img');
    img.src = snowflakeImage;
    return [img];
  }, []);

  return (
    <Snowfall
      snowflakeCount={150}
      speed={[0.5, 2]}
      images={images}
      radius={[6, 12]}
    />
  );
};
